import React from 'react';

import {
  useArchiveBusinessPartner,
  useRestoreBusinessPartner,
  useRemoveBusinessPartner,
  useMoveToTestBusinessPartner,
} from '../../data';
import { Actions } from './Actions';

export const BPActions = ({ actions, data, onDelete, onEdit }) => {
  const [archiveBP] = useArchiveBusinessPartner();
  const [restoreBP] = useRestoreBusinessPartner();
  const [deleteBP] = useRemoveBusinessPartner();
  const [moveToTestBP] = useMoveToTestBusinessPartner();
  const handleDelete = async () => {
    await deleteBP(data);
    onDelete?.(data);
  };

  const handleEdit = () => onEdit?.(data);
  const handleArchive = () => archiveBP(data);
  const handleRestore = () => restoreBP(data);
  const handleMoveToTest = () => moveToTestBP(data);

  return (
    <Actions
      actions={actions}
      onDelete={handleDelete}
      onEdit={handleEdit}
      onArchive={handleArchive}
      onRestore={handleRestore}
      onMoveToTest={handleMoveToTest}
    />
  );
};

export default BPActions;
